module.exports = __webpack_public_path__ + "static/media/button_trello_connection.e74214a1.svg";